<template>
  <div>
    <b-card>
      <b-card-title class="mb-1">ตั้งค่านำเข้าสำหรับลูกค้าแต่ละคน</b-card-title>
      <b-card-sub-title class="mb-2">
        ตั้งเรทเฉพาะรายให้ลูกค้า ถ้าไม่ได้ตั้งช่องไหน ระบบจะใช้เรทมาตรฐานแทน
      </b-card-sub-title>

      <!-- ค้นหาลูกค้า -->
      <b-row class="mb-1">
        <b-col cols="12" md="3" class="mb-1 mb-md-0">
          <v-select
            v-model="searchField"
            :options="searchFieldItems"
            label="text"
            :clearable="false"
          />
        </b-col>
        <b-col cols="12" md="6">
          <b-input-group>
            <b-form-input
              v-model="keyword"
              :placeholder="`ค้นหาโดย ${searchField.text}`"
              @keyup.enter="onSearch"
            />
            <b-input-group-append>
              <b-button variant="primary" :disabled="searching" @click="onSearch">
                <b-spinner v-if="searching" small /> ค้นหา
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        :items="customerList"
        :fields="fields"
        responsive
        hover
        small
        show-empty
        empty-text="ไม่พบลูกค้า"
        class="mb-1"
      >
        <template #cell(name)="data">
          {{ data.item.firstName }} {{ data.item.lastName }}
        </template>
        <template #cell(hasCustomRate)="data">
          <b-badge :variant="data.item.hasCustomRate ? 'success' : 'secondary'">
            {{ data.item.hasCustomRate ? 'มีเรทเฉพาะ' : 'ใช้มาตรฐาน' }}
          </b-badge>
        </template>
        <template #cell(action)="data">
          <b-button size="sm" variant="outline-primary" @click="selectCustomer(data.item)">
            ตั้งเรท
          </b-button>
        </template>
      </b-table>

      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        @input="searchCustomer"
      />
    </b-card>

    <!-- Modal เรทของลูกค้าที่เลือก -->
    <b-modal
      ref="rateModal"
      size="xl"
      scrollable
      hide-footer
      no-close-on-backdrop
      @hidden="onModalHidden"
    >
      <template #modal-title>
        <span v-if="selected">
          เรทของ: {{ selected.firstName }} {{ selected.lastName }}
          <small class="text-muted">({{ selected.userId }})</small>
        </span>
      </template>
      <div v-if="selected">
        <div class="d-flex justify-content-end mb-1">
          <b-button size="sm" variant="outline-danger" :disabled="resetting" @click="resetCustomer">
            <b-spinner v-if="resetting" small /> รีเซ็ตเป็นมาตรฐาน
          </b-button>
        </div>
        <shipping-rate-grid ref="grid" :customer-id="selected.customerId" @saved="onSaved" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import {
  BCard, BCardTitle, BCardSubTitle, BRow, BCol, BInputGroup, BInputGroupAppend,
  BFormInput, BButton, BSpinner, BTable, BBadge, BPagination, BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { header_token } from '@/views/token.js'
import { taobaoService_dotnet } from '@/views/global.js'
import ShippingRateGrid from './ShippingRateGrid.vue'

export default {
  components: {
    BCard, BCardTitle, BCardSubTitle, BRow, BCol, BInputGroup, BInputGroupAppend,
    BFormInput, BButton, BSpinner, BTable, BBadge, BPagination, BModal, vSelect, ShippingRateGrid,
  },
  data() {
    return {
      keyword: '',
      searchField: { text: 'ชื่อ', value: 'name' },
      searchFieldItems: [
        { text: 'ชื่อ', value: 'name' },
        { text: 'เบอร์โทร', value: 'phone' },
        { text: 'Username', value: 'username' },
        { text: 'Taobao ID', value: 'taobaoId' },
      ],
      searching: false,
      resetting: false,
      customerList: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      selected: null,
      fields: [
        { key: 'name', label: 'ชื่อ' },
        { key: 'phoneNumber', label: 'เบอร์โทร' },
        { key: 'userId', label: 'Username' },
        { key: 'taobaoId', label: 'Taobao ID' },
        { key: 'hasCustomRate', label: 'สถานะเรท' },
        { key: 'action', label: '' },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
    this.searchCustomer()
  },
  methods: {
    // กดปุ่มค้นหา/enter -> กลับหน้าแรกเสมอ
    onSearch() {
      this.currentPage = 1
      this.searchCustomer()
    },

    async searchCustomer() {
      this.searching = true
      try {
        const res = await axios.post(
          taobaoService_dotnet + 'app/AdminShippingRate/customer-list',
          {
            loginToken: '',
            branchID: this.userData && this.userData.data ? this.userData.data.branchID : 0,
            keyword: this.keyword.trim(),
            searchField: this.searchField ? this.searchField.value : '',
            skip: (this.currentPage - 1) * this.perPage,
            take: this.perPage,
          },
          { headers: header_token },
        )
        this.customerList = res.data.items || []
        this.totalRows = res.data.totalRows || 0
      } catch (e) {
        this.$bvToast.toast('ค้นหาลูกค้าไม่สำเร็จ', { title: 'ผิดพลาด', variant: 'danger', solid: true })
      } finally {
        this.searching = false
      }
    },

    selectCustomer(item) {
      this.selected = { ...item }
      this.$refs.rateModal.show()
    },

    onModalHidden() {
      this.selected = null
    },

    onSaved() {
      // อัปเดตสถานะเรทในตารางหลังบันทึก
      this.searchCustomer()
    },

    resetCustomer() {
      this.$swal({
        title: 'รีเซ็ตเรทลูกค้า?',
        text: 'เรทเฉพาะของลูกค้าจะถูกลบ และกลับไปใช้เรทมาตรฐาน',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'รีเซ็ต',
        cancelButtonText: 'ยกเลิก',
      }).then(async result => {
        if (!result.value) return
        this.resetting = true
        try {
          const res = await axios.post(
            taobaoService_dotnet + 'app/AdminShippingRate/reset-customer',
            { loginToken: '', customerID: this.selected.customerId },
            { headers: header_token },
          )
          if (res.data && res.data.status === 'success') {
            this.$bvToast.toast('รีเซ็ตเรียบร้อย', { title: 'สำเร็จ', variant: 'success', solid: true })
            if (this.$refs.grid) this.$refs.grid.load()
            this.searchCustomer()
          } else {
            this.$bvToast.toast(res.data.message || 'รีเซ็ตไม่สำเร็จ', { title: 'ผิดพลาด', variant: 'danger', solid: true })
          }
        } catch (e) {
          this.$bvToast.toast('รีเซ็ตไม่สำเร็จ', { title: 'ผิดพลาด', variant: 'danger', solid: true })
        } finally {
          this.resetting = false
        }
      })
    },
  },
}
</script>
